import React, { useState, useEffect } from "react";
import "./Header.css";
import logo from '../../assets/logo/test-transparent.svg';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  // Only the home page has a hero for the header to float over. Everywhere
  // else it stays solid so the links stay legible against the page.
  const overlaysHero = pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Lock body scroll while the mobile drawer is open.
  useEffect(() => {
    document.body.style.overflow = mobileMenuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileMenuOpen]);

  const scrollToContact = () => {
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
    setMobileMenuOpen(false);
  };

  const handleNavClick = () => {
    setMobileMenuOpen(false);
  };

  const solid = scrolled || mobileMenuOpen || !overlaysHero;

  return (
    <>
      <header className={`custom-header ${solid ? 'is-solid' : ''}`}>
        <div className="header-inner">
          <Link to="/" className="logo-link" onClick={handleNavClick}>
            <img src={logo} alt="Pinto Painting Inc." className="logo" />
          </Link>

          <nav className="nav-links">
            <a href="#about">About</a>
            <Link to="/projects">Projects</Link>
            <button onClick={scrollToContact} className="btn btn-primary btn-nav">
              Free Estimate
            </button>
          </nav>

          <button
            className={`hamburger-btn ${mobileMenuOpen ? 'open' : ''}`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
            aria-expanded={mobileMenuOpen}
            aria-controls="mobile-nav"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </header>

      {/*
        Deliberately a sibling of <header>, not a child. The header carries
        backdrop-filter when solid, and any non-none filter/backdrop-filter/
        transform makes an element a containing block for its position: fixed
        descendants — which would collapse this drawer to the header's own
        height. Keep it outside so it always resolves against the viewport.
      */}
      <nav
        id="mobile-nav"
        className={`mobile-nav ${mobileMenuOpen ? 'open' : ''}`}
      >
        <a href="#about" onClick={handleNavClick}>About</a>
        <Link to="/projects" onClick={handleNavClick}>Projects</Link>
        <button onClick={scrollToContact} className="btn btn-primary">
          Free Estimate
        </button>
      </nav>
    </>
  );
}
